import React from 'react'

import { Babi as BabiUi } from '@interco/inter-ui/components/Babi'

import * as S from './styles'

export const Babi = () => (
  <S.ContainerBabi>
    <BabiUi origin="INFORME_RENDIMENTOS" />
  </S.ContainerBabi>
)
